import React from 'react'
import PropTypes from 'prop-types'

import { priceTableTitle, priceTableSubTitle } from '../constants'
import useStyles from './title-section.styles'

/**
 * Component displays price table title and subtitle
 */
const TitleSection = ({ titleClassName = '' }) => {
  const styles = useStyles()

  return (
    <>
      <span className={titleClassName || styles.title}>{priceTableTitle}</span>
      <span className={styles.subTitle}>{priceTableSubTitle}</span>
    </>
  )
}

TitleSection.propTypes = {
  titleClassName: PropTypes.string
}

export default TitleSection
